module.exports = {
  "/": {
    "name": "home",
    "success": {
      "homepage courses loaded": [
        "HOMEPAGE_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_INPROGRESS_LOADED"
      ],
      "homepage courses missing": [
        "HOMEPAGE_API_404"
      ]
    },
    "error": [
      "HOMEPAGE_API_ERROR"
    ]
  },
  "/welcome": {
    "name": "welcome",
    "success": {
      "default": [
        "WELCOME_VIEW_LOADED"
      ]
    }
  },
  "/wizard": {
    "name": "wizard",
    "success": {
      "default": [
        "WIZARD_VIEW_LOADED"
      ]
    }
  },
  "/wizard/*": {
    "name": "wizard-subpage",
    "success": {
      "default": [
        "WIZARD_VIEW_LOADED"
      ]
    }
  },
  "/results": {
    "name": "catalog",
    "success": {
      "catalog courses loaded": [
        "CATALOG_COURSES_LOADED"
      ],
      "catalog courses missing": [
        "CATALOG_COURSES_API_404"
      ]
    },
    "error": [
      "CATALOG_COURSES_API_ERROR"
    ]
  },
  "/tracks": {
    "name": "catalog-old",
    "success": {
      "catalog courses loaded": [
        "CATALOG_COURSES_LOADED"
      ],
      "catalog courses missing": [
        "CATALOG_COURSES_API_404"
      ]
    },
    "error": [
      "CATALOG_COURSES_API_ERROR"
    ]
  },
  "/results/page/:page": {
    "name": "catalog-paginated",
    "success": {
      "catalog courses loaded": [
        "CATALOG_COURSES_LOADED"
      ],
      "catalog courses missing": [
        "CATALOG_COURSES_API_404"
      ]
    },
    "error": [
      "CATALOG_COURSES_API_ERROR"
    ]
  },
  "/results/course-overview/:trackId": {
    "name": "results-course-overview",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/results/course-overview/:trackId/:language": {
    "name": "results-course-overview-language",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/results/lesson-overview/:lessonId": {
    "name": "results-lesson-overview",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/results/lesson-overview/:lessonId/:language": {
    "name": "results-lesson-overview-language",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/tracks/:trackId/exam/award/:trackId/:awardName": {
    "name": "course-award-view",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/tracks/award/:trackId/:awardName": {
    "name": "award-view",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/tracks/:trackId/:lessonId/:contentId": {
    "name": "track-content",
    "success": {
      "course loaded": [
        "COURSE_VIEW_LOADED"
      ],
      "course missing": [
        "COURSE_VIEW_API_404"
      ]
    },
    "error": [
      "COURSE_VIEW_CONTENT_MISSING_ERROR",
      "COURSE_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/intro": {
    "name": "track-intro",
    "success": {
      "intro loaded": [
        "COURSE_INTRO_VIEW_LOADED"
      ],
      "intro missing": [
        "COURSE_INTRO_VIEW_API_404"
      ]
    },
    "error": [
      "COURSE_INTRO_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/exam": {
    "name": "track-exam",
    "success": {
      "exam loaded": [
        "COURSE_EXAM_VIEW_LOADED"
      ],
      "exam missing": [
        "COURSE_EXAM_VIEW_API_404"
      ]
    },
    "error": [
      "COURSE_EXAM_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/complete": {
    "name": "track-conclusion",
    "success": {
      "course complete": [
        "COURSE_CONCLUSION_VIEW_LOADED",
        "COURSE_CONCLUSION_COMPLETE_VIEW_LOADED"
      ],
      "course incomplete": [
        "COURSE_CONCLUSION_VIEW_LOADED",
        "COURSE_CONCLUSION_INCOMPLETE_VIEW_LOADED"
      ]
    }
  },
  "/tracks/:trackId": {
    "name": "track",
    "success": {
      "course missing": [
        "COURSE_VIEW_API_404"
      ]
    },
    "error": [
      "COURSE_VIEW_CONTENT_MISSING_ERROR",
      "COURSE_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/:lessonId": {
    "name": "track-lesson",
    "success": {
      "course missing": [
        "COURSE_VIEW_API_404"
      ],
      "lesson missing": [
        "LESSON_VIEW_API_404"
      ]
    },
    "error": [
      "COURSE_VIEW_CONTENT_MISSING_ERROR",
      "COURSE_VIEW_API_ERROR"
    ]
  },
  "/partners/course-overview/:trackId": {
    "name": "partners-course-overview",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/partners/course-overview/:trackId/:language": {
    "name": "partners-course-overview-language",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/partners": {
    "name": "partners",
    "success": {
      "partners loaded": [
        "CATALOG_COURSES_LOADED"
      ],
      "partners missing": [
        "CATALOG_COURSES_API_404"
      ]
    },
    "error": [
      "CATALOG_COURSES_API_ERROR"
    ]
  },
  "/partners/lesson-overview/:lessonId": {
    "name": "partners-lesson-overview",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/partners/lesson-overview/:lessonId/:language": {
    "name": "partners-lesson-overview-language",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/course-overview/:trackId": {
    "name": "course-overview",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/course-overview/:trackId/:language": {
    "name": "course-overview-language",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/lesson-overview/:lessonId": {
    "name": "lesson-overview",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/lesson-overview/:lessonId/:language": {
    "name": "lesson-overview-language",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/mylearning/:status/course-overview/:trackId": {
    "name": "mylearning-course-overview",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/mylearning/:status/course-overview/:trackId/:language": {
    "name": "mylearning-course-overview-language",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/mylearning/:status/lesson-overview/:lessonId": {
    "name": "mylearning-lesson-overview",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/mylearning/:status/lesson-overview/:lessonId/:language": {
    "name": "mylearning-lesson-overview-language",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/mylearning/:status": {
    "name": "my-learning",
    "success": {
      "courses loaded": [
        "MYLEARNING_LISTING_LOADED"
      ],
      "courses missing": [
        "MYLEARNING_LISTING_API_404"
      ]
    },
    "error": [
      "MYLEARNING_LISTING_API_ERROR"
    ]
  },
  "/mylearning": {
    "name": "my-learning-redirect"
  },
  "/saved-items/watch-later/course-overview/:trackId": {
    "name": "favorites-course-overview",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/saved-items/watch-later/course-overview/:trackId/:language": {
    "name": "favorites-course-overview-language",
    "success": {
      "course overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "course overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/saved-items/watch-later/lesson-overview/:lessonId": {
    "name": "favorites-lesson-overview",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/saved-items/watch-later/lesson-overview/:lessonId/:language": {
    "name": "favorites-lesson-overview-language",
    "success": {
      "lesson overview loaded": [
        "OVERVIEW_MODAL_LOADED"
      ],
      "lesson overview missing": [
        "OVERVIEW_MODAL_API_404"
      ]
    },
    "error": [
      "OVERVIEW_MODAL_API_404"
    ]
  },
  "/saved-items/watch-later": {
    "name": "favorites",
    "success": {
      "favorites loaded": [
        "FAVORITES_LISTING_LOADED"
      ],
      "favorites missing": [
        "FAVORITES_LISTING_API_404"
      ]
    },
    "error": [
      "FAVORITES_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists": {
    "name": "my-playlists",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/create-playlist": {
    "name": "create-playlist",
    "success": {
      "create playlist loaded": [
        "CREATE_PLAYLIST_LOADED"
      ]
    }
  },
  "/partners/page/:page/create-playlist": {
    "name": "create-playlist",
    "success": {
      "create playlist loaded": [
        "CREATE_PLAYLIST_LOADED"
      ]
    }
  },
  "/mylearning/in-progress/create-playlist": {
    "name": "create-playlist",
    "success": {
      "create playlist loaded": [
        "CREATE_PLAYLIST_LOADED"
      ]
    }
  },
  "/create-playlist": {
    "name": "create-playlist",
    "success": {
      "create playlist loaded": [
        "CREATE_PLAYLIST_LOADED"
      ]
    }
  },
  "/results/create-playlist": {
    "name": "create-playlist",
    "success": {
      "create playlist loaded": [
        "CREATE_PLAYLIST_LOADED"
      ]
    }
  },
  "/saved-items/playlists/:playlistId/edit-playlist": {
    "name": "edit-playlist",
    "success": {
      "edit playlist loaded": [
        "EDIT_PLAYLIST_LOADED"
      ]
    }
  },
  "/saved-items/playlists/:playlistId/duplicate-playlist": {
    "name": "duplicate-playlist",
    "success": {
      "edit playlist loaded": [
        "DUPLICATE_PLAYLIST_LOADED"
      ]
    }
  },
  "/team": {
    "name": "team",
    "success": {
      "team loaded": [
        "TEAM_VIEW_LOADED"
      ],
      "team missing": [
        "TEAM_VIEW_API_404"
      ]
    },
    "error": [
      "TEAM_VIEW_API_ERROR"
    ]
  },
  "/lessons/:lessonId/:contentId": {
    "name": "lesson-content",
    "success": {
      "lesson loaded": [
        "LESSON_VIEW_LOADED"
      ],
      "lesson missing": [
        "LESSON_VIEW_API_404"
      ]
    },
    "error": [
      "LESSON_VIEW_API_ERROR"
    ]
  },
  "/lessons/:lessonId": {
    "name": "lesson",
    "success": {
      "lesson missing": [
        "LESSON_VIEW_API_404"
      ]
    },
    "error": [
      "LESSON_VIEW_API_ERROR"
    ]
  },
  "/award-share/:trackId/:awardName": {
    "name": "award-share-controls",
    "success": {
      "award share controls loaded": [
        "AWARD_SHARE_CONTROLS_LOADED"
      ]
    }
  },
  "/award-share/:trackId/:awardName/achievement-preview": {
    "name": "award-share-achievement-preview",
    "success": {
      "achievement loaded": [
        "ACHIEVEMENT_LOADED"
      ],
      "achievement missing": [
        "ACHIEVEMENT_MISSING"
      ]
    }
  },
  "/achievements/:publicId": {
    "name": "achievements-public",
    "success": {
      "achievement loaded": [
        "ACHIEVEMENT_LOADED"
      ],
      "achievement missing": [
        "ACHIEVEMENT_MISSING"
      ]
    }
  },
  "/practical-exercise/:contentId/:lessonId": {
    "name": "practical-exercise",
    "success": {
      "practical exercise loaded": [
        "PRACTICAL_EXERCISE_LOADED"
      ]
    }
  },
  "/practical-exercise/:contentId/:lessonId/:trackId": {
    "name": "practical-exercise-with-track",
    "success": {
      "practical exercise loaded": [
        "PRACTICAL_EXERCISE_LOADED"
      ]
    }
  }
};